import React from "react";
import { useSelector } from "react-redux";
import { Layout, Menu } from "antd";



const Dashboard = () => {
  const user = useSelector((state) => state.user.user);

  return <>Dashboard View</>;
};

export default Dashboard;
